import { render, staticRenderFns } from "./modalEditBusinessEvent.vue?vue&type=template&id=ddd91962&"
import script from "./modalEditBusinessEvent.vue?vue&type=script&lang=js&"
export * from "./modalEditBusinessEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports